import { IApplicationState } from '../../types/redux';

export const getRegions = (state: IApplicationState) => state.developerV2?.regions || [];
